import { render } from "./Chapter9Deduction.vue?vue&type=template&id=21e9408e&scoped=true"
import script from "./Chapter9Deduction.vue?vue&type=script&lang=js"
export * from "./Chapter9Deduction.vue?vue&type=script&lang=js"

import "./Chapter9Deduction.vue?vue&type=style&index=0&id=21e9408e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e9408e"]])

export default __exports__